import classnames from 'classnames';
import React from 'react';
import { Colors } from '../../../../enums/colors.js';
import { Widths } from '../../../../enums/widths.js';
import { BaseTooltip } from '../base-tooltip/base-tooltip.js';
import classes from './styles/standard-tooltip.module.scss.js';

const StandardTooltip = (props)=>{
    const { className, color = Colors.Primary, width = Widths.Medium, wrapperProps, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseTooltip, {
        ...otherProps,
        className: classnames(classes.tooltip, !!color && classes[color], !!width && classes[width], className),
        variantName: "standard",
        wrapperProps: {
            ...wrapperProps,
            className: classnames(classes.wrapper, wrapperProps && wrapperProps.className)
        }
    });
};

export { StandardTooltip };
//# sourceMappingURL=standard-tooltip.js.map
